import { Component, Input } from '@angular/core';
import { Node } from '../../../d3';

@Component({
    selector: '[nodeVisual]',
    template: `
        <svg:g [attr.transform]="'translate(' + node.x + ',' + node.y + ')'">
            <svg:circle [ngClass]="node.nodeClass" [attr.fill]="node.color" cx="0" cy="0" [attr.r]="node.r"></svg:circle>
            <svg:text [ngClass]="node.textClass" [attr.font-size]="node.fontSize">
                <ng-container *ngFor="let line of getWrappedText(node.label, 25); let i = index">
                    <tspan x="0" [attr.dy]="i === 0 ? '0' : '1.2em'">{{ line }}</tspan>
                </ng-container>
            </svg:text>
            <svg:title>
                {{ node.label }}
            </svg:title>
        </svg:g>
    `,
})
export class NodeVisualComponent {
    @Input('nodeVisual')
    node!: Node;

    getWrappedText(text: string, maxLength: number): Array<string> {
        const words = text.split(' ');
        const lines: Array<string> = [];
        let currentLine = '';

        words.forEach((word) => {
            if ((currentLine + word).length <= maxLength) {
                currentLine += word + ' ';
            } else {
                lines.push(currentLine.trim());
                currentLine = word + ' ';
            }
        });

        if (currentLine.trim().length > 0) {
            lines.push(currentLine.trim());
        }

        return lines;
    }
}
